export enum PlayerTransactionTypeEnum {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
  BONUS_DEPOSIT = 'BONUS_DEPOSIT',
  BONUS_WITHDRAW = 'BONUS_WITHDRAW',
  BET = 'BET',
  WIN = 'WIN',
  WIN_BONUS_RELEASE = 'WIN_BONUS_RELEASE',
  ROLLBACK_WIN = 'ROLLBACK_WIN',
  ROLLBACK_BET = 'ROLLBACK_BET',
}
